export default function CircularProgress({
  size = 30,
  color = 'var(--primary-color)',
  borderColor,
  thickness = 4,
  className,
}) {
  const s = typeof size === 'number' ? `${size}px` : size;

  return (
    <div
      className={`circularProgress ${className}`}
      style={{ color, width: s, height: s, borderWidth: thickness, ...(borderColor && {borderColor}) }}></div>
  );
}
